export const breakpoints = {
  largeDesktop: '1440px',
  desktop: '1200px',
  laptop: '992px',
  tablet: '768px',
  mobile: '576px',
  smallMobile: '360px',

  abs: {
    largeDesktop: 1440,
    desktop: 1200,
    laptop: 992,
    tablet: 768,
    mobile: 576,
    smallMobile: 360,
  },
};

const dark = '#152438';

export const colors = {
  light: '#ffffff',
  dark,

  // brand
  simba: '#b3721e',
  blue: '#97b9bd',
  brown: '#B7AEA2',

  gray0: '#fafafa',
  gray1: '#f4f6f8',
  gray2: '#e8eef7',
  gray3: '#d5d6d6',
  gray4: '#b5b5b5',
  gray5: '#787878',

  green: '#00C851',
  red: '#BD1550',
  aqua: '#3498db',
  lagoon: '#255D6D',
  peach: '#F9E2CE',
  rose: '#DB7878',
  tomato: '#ff5252',
  silver: '#C0C0C0',
  purple: '#9333ea',
  yellow: '#FFBB00',

  // special
  stripe: '#635bff',
  whatsapp: '#25D366',

  // gradients
  linearBlue: `linear-gradient(to bottom right, ${dark}, ${dark}, #203144, ${dark}, ${dark})`,
};
